export const policyNumberRegex = /^[a-zA-Z0-9-]+$/;
